import { IoIosCloseCircle } from "react-icons/io";
import styles from './css/tabMenu.module.css';


export default function TabMenu({title, onClose, onHeaderBody, header, children}){
    return (
        <div className={styles.component}>
            <div className={styles.overlay} onClick={() => onClose()}/>

            <div className={styles.container}>
                {!onHeaderBody ? (
                    <div className={styles.headerCompanyBox}>
                        <div className={styles.headerSubContainer}>
                            <div className={styles.headerSubContainer} style={{width: 'auto', justifyContent: 'flex-start'}}>
                                <p className={styles.title}>{title}</p>
                            </div>
                
                            {onClose ? (
                                <button className={styles.closeButton} onClick={() => onClose()}>
                                    <IoIosCloseCircle size={30} color="#fff" />
                                </button>
                            ) : null}
                        </div>
                    </div>

                ) : (
                    <>
                        {header}
                    </>
                )}

                {children}
            </div>
        </div>
    )
}